import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Render the canvas index svg
 */
export default function CanvasIndexIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M6.924,21H21V19H6.924ZM3,17H21V15H3Zm3.924-4H21V11H6.924Zm0-4H21V7H6.924ZM3,3V5H21V3Z" />
      </svg>
    </SvgIcon>
  );
}
